import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { TOPBAR_HEIGHT } from 'app/layout/dashboard/Dashboard.utils';

export const useStyles = makeStyles<Theme>(
  ({ spacing, palette: { white, green, black }, typography: { fontWeightBold }, breakpoints }) => ({
    content: {
      display: 'flex',
      justifyContent: 'center',
      fontFamily: 'Open Sans',
      fontSize: spacing(8),
      fontWeight: fontWeightBold,
      marginTop: spacing(20),
    },
    container: {
      backgroundColor: white.dark,
    },
    emailTitle: {
      fontWeight: `${fontWeightBold} !important`,
      fontSize: `${spacing(6.5)} !important`,
      justifyContent: 'center',
      display: 'flex',
      fontFamily: `Open Sans !important`,
      marginBottom: `${spacing(0.25)} !important`,
      lineHeight: spacing(5),
    },
    emailDescription: {
      fontSize: spacing(2),
      justifyContent: 'center',
      display: 'flex',
      fontFamily: `roboto`,
      textAlign: 'center',
      marginBottom: `${spacing(1)} !important`,
      color: '#00000',
      opacity: 0.5,
    },
    card: {
      margin: 'auto',
      width: spacing(78.5),
      // height: spacing(36),
      backgroundColor: white.light,
      borderRadius: spacing(1.25),
      padding: spacing(2),
      marginTop: spacing(20),
    },
    emailInput: {
      padding: spacing(1),
      marginBottom: `${spacing(2)} !important`,
    },
    button: {
      width: '100%',
      backgroundColor: `${green.main} !important`,
      color: `${white.main} !important`,
      marginTop: `${spacing(2)} !important`,
    },
    clientText: {
      fontSize: `${spacing(4)} !important`,
      fontStyle: `Open Sans !important`,
      textAlign: 'center',
      fontWeight: `${fontWeightBold}  !important`,
      color: '#595959',
    },
    imageContainer: {
      display: 'flex',
      padding: spacing(4),
      justifyContent: 'center',
      HeaderImage: {
        padding: spacing(4),
      },
      margin: spacing(1, 4, 0, 4),
    },
    images: {
      margin: spacing(0, 6, 0, 6),
    },
    root: {
      height: `calc(100vh - ${TOPBAR_HEIGHT}px)`,
      // height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    cardContainer: {
      [breakpoints.up('md')]: {
        marginTop: spacing(8),
      },
    },
    link: {
      display: 'flex',
      justifyContent: 'center',
      color: `${black.dark} !important`,
      fontWeight: `${fontWeightBold} !important`,
      marginTop: `${spacing(1)} !important`,
      fontFamily: `Open Sans !important`,
    },
    icon: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: spacing(1),
    },
    institutionContainer: {
      [breakpoints.down('md')]: {
        display: 'none',
      },
      marginBottom: `${spacing(5)} !important`,
    },
    stageClipLogo: {
      height: '10%',
      [breakpoints.up('md')]: {
        display: 'none',
      },
      margin: spacing(1, 0, 1, 2.5),
      display: 'flex',
      justifyContent: 'center',
      marginBottom: `${spacing(1)} !important`,
    },
  }),
);
